import { v4 as uuid, v4 } from "uuid"
import { Serializable } from "@/core/api/decorators/serializable_decorator"
import { TaskStatus } from "../constants/taskStatus"
import { IsNotEmpty } from "class-validator"
import {
  IsDateAfter,
  IsRelatedDateAfter,
} from "../core/utils/validators/IsOnlyOneFIlled"
import { IsValidDate } from "../core/utils/validators/IsValidDate"

@Serializable
export class MainTaskModel {
  uid: string = v4()

  @IsNotEmpty({
    message: "agreement_information.agreement_title_error",
    groups: ["agreement_information", "edit_agreement_details"],
  })
  name: string = ""
  agreementNumber: string = ""
  description: string = ""
  state: string = TaskStatus.Drafted

  @IsNotEmpty({ message: "select_option_error", groups: ["agreement_type"] })
  agreementType: number | null = null
  @IsNotEmpty({
    message: "select_option_error",
    groups: ["agreement_owner", "edit_agreement_details"],
  })
  agreementOwnerId: string = ""
  agreementOwnerName: string = ""
  @IsNotEmpty({
    message: "about_customer.customer_error",
    groups: ["about_customer"],
  })
  customerId: string = ""
  customerName: string = ""

  @IsValidDate({
    message: "common:invalid_date",
    groups: ["dates", "edit_agreement_details"],
  })
  @IsNotEmpty({
    message: "error_fill",
    groups: ["dates", "edit_agreement_details"],
  })
  // @IsDateAfter(new Date(), {
  //   message: "dates.start_date_after_today",
  //   groups: ["dates", "edit_agreement_details"],
  // })
  startDate: string = ""

  @IsValidDate({
    message: "common:invalid_date",
    groups: ["dates", "edit_agreement_details"],
  })
  @IsNotEmpty({
    message: "error_fill",
    groups: ["dates", "edit_agreement_details"],
  })
  @IsRelatedDateAfter("startDate", {
    message: "dates.end_date_after_start_date",
    groups: ["dates", "edit_agreement_details"],
  })
  @IsDateAfter(new Date(), {
    message: "dates.end_date_after_today",
    groups: ["dates", "edit_agreement_details"],
  })
  endDate: string = ""
  hasExtensionOption: boolean = false
  numOptionYears: number = 0
  priceAdjustmentDay: number = 1
  priceAdjustmentMonth: number = 1
  stepIndex: number = 1
  isWizzardCompleted: boolean = false

  constructor(
    data: {
      uid: string
      name: string
      agreementNumber: string
      description: string
      state: string
      agreementType: number
      agreementOwnerId: string
      agreementOwnerName: string
      customerId: string
      customerName: string
      startDate: string
      endDate: string
      hasExtensionOption: boolean
      numOptionYears: number
      priceAdjustmentDay: number
      priceAdjustmentMonth: number
      stepIndex: number
      isWizzardCompleted: boolean
    } | null = null,
  ) {
    if (data) {
      this.uid = data.uid
      this.name = data.name
      this.agreementNumber = data.agreementNumber
      this.description = data.description
      this.state = data.state
      this.agreementType = data.agreementType
      this.agreementOwnerId = data.agreementOwnerId
      this.agreementOwnerName = data.agreementOwnerName
      this.customerId = data.customerId
      this.customerName = data.customerName
      this.startDate = data.startDate
      this.endDate = data.endDate
      this.hasExtensionOption = data.hasExtensionOption
      this.numOptionYears = data.numOptionYears
      this.priceAdjustmentDay = data.priceAdjustmentDay
      this.priceAdjustmentMonth = data.priceAdjustmentMonth
      this.stepIndex = data.stepIndex
      this.isWizzardCompleted = data.isWizzardCompleted
    }
  }
}
